// Fire on load event to prevent getting the banner height before the layout is done rendering
var fixedHeaderMerginFn = function fixedHeaderMerginFn() {
  var pageMarginTop = $('.page').css('margin-top');
  // Only use the margin-top if it's a pixel value
  if (!pageMarginTop || !pageMarginTop.includes('px')) {
    clearInterval(headerResizeTimer);
    return;
  }
  pageMarginTop = Number(pageMarginTop.slice(0, -2));
  var fixedHeaderHeight = $('.fixed-header').height();

  // Only adjust the .page margin-top if the height difference is too big
  if (Math.abs(fixedHeaderHeight - pageMarginTop) >= 2) {
    $('.page').css('margin-top', fixedHeaderHeight + 'px');
  }
};
try {
  var observer = new ResizeObserver(fixedHeaderMerginFn);

  // Initialize the observer to watch for changes in the fixed header size
  observer.observe(document.querySelector('.fixed-header'));
} catch (e) {
  // ResizeObserver is not supported
  console.warn('ResizeObserver is not supported in this browser. Fixed header margin may not adjust correctly on resize.');

  // Set an interval to periodically check the header size
  var _headerResizeTimer = setInterval(fixedHeaderMerginFn, 500);
  window.addEventListener('load', function () {
    clearInterval(_headerResizeTimer);
  });
}

// Also set an interval to check for changes in case ResizeObserver misses something
window.addEventListener('load', fixedHeaderMerginFn);
module.exports = require('core/components/menu');